import { User, Users, GraduationCap, Building } from "lucide-react";

const audiences = [
  { 
    icon: User, 
    title: "Individuals",
    desc: "Seeking structured entry into trading and Web3" 
  },
  { 
    icon: Users, 
    title: "Communities",
    desc: "Preparing to engage with AI-powered tools" 
  },
  { 
    icon: GraduationCap, 
    title: "Educators",
    desc: "Organizers focused on disciplined learning" 
  },
  { 
    icon: Building, 
    title: "Organizations",
    desc: "Seeking credible education collaborators" 
  }
];

const WhoThisIsFor = () => {
  return (
    <section data-testid="who-this-is-for-section" className="section-primary">
      <div className="section-pattern"></div>
      
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Who This Is For</h2>
          <div className="section-divider"></div>
        </div>
        
        <div className="who-grid">
          {audiences.map((audience, index) => (
            <div key={index} className="who-card" data-testid={`who-block-${index}`}>
              <div className="who-card-icon">
                <audience.icon />
              </div>
              <h3 className="who-card-title">{audience.title}</h3>
              <p className="who-card-desc">{audience.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoThisIsFor;
